import React, { FC, ReactNode } from "react";

import { Modal, ModalHead, Sizes } from "@/components/molecules/modals/Modal";

interface Props {
  isOpen: boolean;
  close: () => void;
  children: ReactNode;
}

export const MainBlockModal: FC<Props> = ({ isOpen, close, children }) => {
  return (
    <Modal
      isOpen={isOpen}
      handleClose={close}
      size={Sizes.XXXXXL}
      spSize="mainBlock"
    >
      <ModalHead onClickClose={close} />

      <div>{children}</div>
    </Modal>
  );
};
